// extracted by mini-css-extract-plugin
export default {"footer":"djBqW","content":"fjzQA ZdH1P","copyright":"sOCuF","container":"OL0WV ZdH1P"};